'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('@dekk/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */


/**
 * @public
 * @param {Object} props
 *   The properties
 * @param {String} props.channel
 * @param {Boolean} props.publish
 * @param {Boolean} props.subscribe
 * @param {number} props.slideIndex
 *   (Injected via Dekk)
 * @param {number} props.fragmentIndex
 *   (Injected via Dekk)
 * @param {Function} props.toFragment
 *   (Injected via Dekk)
 * @param {Function} props.toSlide
 *   (Injected via Dekk)
 * @example
 * import Deck, {Plugins} from '@dekk/deck'
 * import LocalStorage from '@dekk/local-storage'
 *
 * export default (
 *   <Deck>
 *     <Plugins>
 *       <LocalStorage subscribe/>
 *     </Plugins>
 *   </Deck>
 * )
 */
var LocalStorage = function (_Component) {
  _inherits(LocalStorage, _Component);

  _createClass(LocalStorage, null, [{
    key: 'propTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        channel: _propTypes2.default.string,
        subscribe: _propTypes2.default.bool,
        publish: _propTypes2.default.bool,
        slideIndex: _propTypes2.default.number,
        fragmentIndex: _propTypes2.default.number,
        toFragment: _propTypes2.default.func,
        toSlide: _propTypes2.default.func
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        channel: '@dekk',
        subscribe: false,
        publish: false,
        slideIndex: 0,
        fragmentIndex: 0,
        toFragment: function toFragment() {
          return null;
        },
        toSlide: function toSlide() {
          return null;
        }
      };
    }

    /**
     * @public
     * @param {Object} props
     *   The properties
     * @param {String} props.channel
     * @param {Boolean} props.publish
     * @param {Boolean} props.subscribe
     * @param {number} props.slideIndex
     *   (Injected via Dekk)
     * @param {number} props.fragmentIndex
     *   (Injected via Dekk)
     * @param {Function} props.toFragment
     *   (Injected via Dekk)
     * @param {Function} props.toSlide
     *   (Injected via Dekk)
     */

  }]);

  function LocalStorage(props) {
    _classCallCheck(this, LocalStorage);

    var _this = _possibleConstructorReturn(this, (LocalStorage.__proto__ || Object.getPrototypeOf(LocalStorage)).call(this, props));

    _this.handleStore = _this.handleStore.bind(_this);
    return _this;
  }

  /**
   * @private
   */


  _createClass(LocalStorage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.subscribe) {
        var oldValue = window.localStorage.getItem(this.props.channel);
        try {
          this.handleMessage(JSON.parse(oldValue));
        } finally {
          window.addEventListener('storage', this.handleStore);
        }
      }
    }

    /**
     * Unsubscribe when unmounted
     * @private
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.subscribe) {
        window.removeEventListener('storage', this.handleStore);
      }
    }

    /**
     * When the props change we need to publish the changes.
     * To prevent flooding we only publish when the slideIndex or fragmentIndex
     * change.
     * @private
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var slideIndex = _ref.slideIndex,
          fragmentIndex = _ref.fragmentIndex,
          publish = _ref.publish;

      if (publish) {
        if (slideIndex !== this.props.slideIndex || fragmentIndex !== this.props.fragmentIndex) {
          var message = {
            slideIndex: slideIndex,
            fragmentIndex: fragmentIndex
          };
          window.localStorage.setItem(this.props.channel, JSON.stringify(message));
        }
      }
    }

    /**
     * Sends the message to localStorage after confirming a difference
     * between the old value and the new value
     * @private
     */

  }, {
    key: 'handleStore',
    value: function handleStore(_ref2) {
      var key = _ref2.key,
          oldValue = _ref2.oldValue,
          newValue = _ref2.newValue;

      if (key === this.props.channel && oldValue !== newValue) {
        this.handleMessage(JSON.parse(newValue));
      }
    }

    /**
     * @private
     * @param {String} message
     *   The mesage that has been sent
     */

  }, {
    key: 'handleMessage',
    value: function handleMessage(message) {
      // Only allow messages of type `object`
      if ((typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object') {
        var slideIndex = message.slideIndex,
            fragmentIndex = message.fragmentIndex;

        if ((0, _utils.isNumeric)(slideIndex) && (0, _utils.isNumeric)(fragmentIndex)) {
          this.props.toSlide(slideIndex);
          this.props.toFragment(fragmentIndex);
        }
      }
    }

    /**
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return LocalStorage;
}(_react.Component);

exports.default = LocalStorage;
//# sourceMappingURL=index.js.map